import SubscribedCommunities from "./SubscribedCommunities";

export default SubscribedCommunities;
